// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-download-button {
  width: 100%;
  display: brock;
}`, "",{"version":3,"sources":["webpack://./src/_core/components/common/UI/FileDownLoadButton.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,cAAA;AACF","sourcesContent":[".file-download-button {\r\n  width: 100%;\r\n  display: brock;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
